import { useEffect } from "react";
import { useBlocker } from "react-router";

/**
 * Pide confirmación al salir del formulario mientras haya archivos subiendo:
 * al salir, el formulario se desmonta y el motor cancela las subidas que no
 * quedaron adjuntas.
 *
 * Cerrar o recargar la pestaña usa el aviso nativo del navegador. La
 * navegación dentro de la app queda bloqueada y se devuelve el `blocker` para
 * que la página muestre su modal (`proceed` sale, `reset` se queda).
 */
export const usePendingUploadsWarning = (hasPendingUploads: boolean) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      hasPendingUploads && currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    if (!hasPendingUploads) return;

    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
    };

    globalThis.window.addEventListener("beforeunload", onBeforeUnload);
    return () =>
      globalThis.window.removeEventListener("beforeunload", onBeforeUnload);
  }, [hasPendingUploads]);

  return blocker;
};
